import React, { FunctionComponent } from 'react';

import { Translate } from 'react-localize-redux';

import moment from 'moment';

import { motion } from 'framer-motion';
import styled from 'styled-components';
import { darken, rgba } from 'polished';

import Typography from '@components/basics/typography';
import DownloadIcon from '@components/basics/icons/download';
import { useDispatch } from 'react-redux';
import { GenerateExportUrl } from '@webapp/store/earnings/action-creators';

interface DownloadBoxProps {
  className?: string;
  artistId: string;
}

const DownloadBox: FunctionComponent<DownloadBoxProps> = ({
  className,
  artistId,
}) => {
  const dispatch = useDispatch();

  const handleDownload = () => {
    dispatch(
      new GenerateExportUrl(
        //update artist or owner type here
        'ARTIST',
        artistId,
        'yearly',
        moment(new Date()).format('YYYY')
      )
    );
    return;
  };

  return (
    <motion.div
      className={className || ''}
      initial="rest"
      whileHover="hover"
      whileTap="click"
      animate="rest"
      onClick={handleDownload}
    >
      <IconWrapper>
        <DownloadIcon color="orange" />
      </IconWrapper>
      <Info>
        <Title type="section-title" customFont="semi-bold">
          <Translate id="EARNINGS.SIDEBAR.ITEM.DOWNLOAD.TITLE" />
        </Title>
        <Text>
          <Translate
            id="EARNINGS.SIDEBAR.ITEM.DOWNLOAD.TEXT"
            data={{ currentYear: moment(new Date()).format('YYYY') }}
          />
        </Text>
      </Info>
    </motion.div>
  );
};

export default styled(DownloadBox)`
  cursor: pointer;
  padding: 32px;
  height: max-content;
  border-radius: 10px;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 18px;
  background-color: ${({ theme }) => theme.colors.box};
  transition: background-color
    ${({ theme }) => `${theme.transitions.duration} ${theme.transitions.type}`};

  &:hover {
    background-color: ${({ theme }) => darken(0.05, theme.colors.midGray)};
  }
`;

const IconWrapper = styled.div`
  flex: 0 0 auto;
  width: 68px;
  height: 68px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  background-color: ${({ theme }) => rgba(theme.colors.upload, 0.1)};

  svg {
    width: 18px;
    height: 18px;
  }
`;

const Info = styled.div``;

const Title = styled(Typography)`
  font-weight: 700;
  margin-bottom: 5px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
`;

const Text = styled(Typography)`
  font-size: ${({ theme }) => theme.typography.span};
  font-weight: 400;
  color: ${({ theme }) => theme.colors.tertiary};
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
`;
